import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: 'Technology That Works the Way Your Business Does',
      description: 'Vendor-neutral solutions delivering security, reliability, and business alignment',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&h=800&fit=crop',
      primaryBtn: 'Discover Our Approach',
      primaryLink: '/about',
      secondaryBtn: 'Speak to an Expert',
      secondaryLink: '/contact'
    },
    {
      title: 'Enterprise-Grade Technology Infrastructure',
      description: 'From networking to cybersecurity, we build and maintain technology that powers your success',
      image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=1200&h=800&fit=crop',
      primaryBtn: 'Explore Technology Services',
      primaryLink: '/services/technology',
      secondaryBtn: 'Speak to an Expert',
      secondaryLink: '/contact'
    },
    {
      title: 'Software Solutions That Drive Growth',
      description: 'CRM, ERP, and custom development tailored to your business processes',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=800&fit=crop',
      primaryBtn: 'View Software Services',
      primaryLink: '/services/software',
      secondaryBtn: 'Speak to an Expert',
      secondaryLink: '/contact'
    },
    {
      title: 'Transform Data Into Strategic Advantage',
      description: 'AI-powered analytics and automation for smarter business decisions',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=800&fit=crop',
      primaryBtn: 'Learn About BI Solutions',
      primaryLink: '/services/intelligence',
      secondaryBtn: 'Speak to an Expert',
      secondaryLink: '/contact'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(timer);
  }, [currentSlide]);

  return (
    <section className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <div className="hero-container">
              <div className="hero-content">
                <h1 className="hero-title">{slide.title}</h1>
                <p className="hero-description">{slide.description}</p>
                <div className="hero-actions">
                  <Link to={slide.primaryLink} className="btn-hero-primary">{slide.primaryBtn}</Link>
                  <Link to={slide.secondaryLink} className="btn-hero-secondary">{slide.secondaryBtn}</Link>
                </div>
              </div>
              <div className="hero-image">
                <img src={slide.image} alt={slide.title} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="hero-nav hero-nav-prev" onClick={prevSlide} aria-label="Previous slide">
        ‹
      </button>
      <button className="hero-nav hero-nav-next" onClick={nextSlide} aria-label="Next slide">
        ›
      </button>

      <div className="hero-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
